module.exports = __webpack_public_path__ + "static/img/shengxu_hong.da3ff524.svg";